import psoLogsSlice, { actions } from "./reducer";
import * as thunkActions from "./actions";
export const psoLogsActions = { ...actions, ...thunkActions };
export * as PsoLogsTypes from './types';
export default psoLogsSlice;
